




















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsTable,
    GenericLoadingSpinner,
    AccountTypeSubheader
  }
})
export default class CurrentHoldings extends Vue {
  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }
}
